/* eslint-disable */
import { IApiResponse, IApiResponseSuccess, LoginData } from "@/@types/lib/api/api";
import { DCRecord } from "@/@types/lib/dataController";
import {
  ActivateData,
  CheckData,
  IAuthService,
  LogoutData,
  RegisterData,
  RequestResetPasswordData,
  ResetPasswordData,
  ChangePasswordData,
  WhoAmIData,
  RegisterCheckOIBData,
  ResendData
} from "@/@types/services/authService";
import api from "../lib/api";
import { sifrarnici } from "@/lib/sifrarnici";

// The authentication service is used to login and logout of the application
export const authService: IAuthService = {
  register,
  activate,
  login,
  logout,
  requestResetPassword,
  checkResetPasswordToken,
  resetPassword,
  changePassword,
  whoAmI,
  confirmRegisterToken,
  checkRegisterOIB,
  resendRegisterToken
};

const authApiUrl = "auth/";
const appKey = process.env.REACT_APP_APPKEY;

function checkRegisterOIB(oib: string): Promise<IApiResponse> {
  const apiInstance = new api();

  let bodyData = {
    oib
  }

  const url = authApiUrl + "register-check-oib";

  return apiInstance.Call(url, "post", bodyData);
}

function register(userData: DCRecord): Promise<RegisterData> {
  const apiInstance = new api();

  console.log(userData)

  const {hps_broj_vodicke_znacke, hps_has_licenca, hps_licenca_do, hps_plan_udruga_oib, hps_spv_oib} = userData;

  let bodyData = {
    first_name: userData.first_name,
    last_name: userData.last_name,
    email: userData.email,
    oib: userData.oib,
    mobitel: userData.mobitel,
    password: userData.password,
    hps_broj_vodicke_znacke,
    hps_has_licenca,
    hps_licenca_do,
    hps_plan_udruga_oib,
    hps_spv_oib
  };

  const url = authApiUrl + "register-request";

  return apiInstance.Call(url, "post", bodyData);
}

function checkResetPasswordToken(token: string): Promise<CheckData> {
  const apiInstance = new api();
  const url = authApiUrl + "password-reset-check/" + token;

  return apiInstance
    .Call(url, "get")
    .then((resp) => {
      if (resp.success) {
        const data = resp.data as CheckData;
        return Promise.resolve(data);
      } else {
        return Promise.reject(resp.error);
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

function confirmRegisterToken(token: string): Promise<CheckData> {
  const apiInstance = new api();
  const url = authApiUrl + "register-confirm/" + token;

  return apiInstance
    .Call(url, "get")
    .then((resp) => {
      if (resp.success) {
        const data = resp.data as CheckData;
        return Promise.resolve(data);
      } else {
        return Promise.reject(resp.error);
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

function resendRegisterToken(token: string, email: string, password: string): Promise<ResendData> {
  const apiInstance = new api();
  const url = authApiUrl + "register-request-resend";
  const data = {
    token: token,
    email: email,
    password: password
  }

  return apiInstance
    .Call(url, "post", data)
    .then((resp) => {
      if (resp.success) {
        const data = resp.data as ResendData;
        return Promise.resolve(data);
      } else {
        return Promise.reject(resp.error);
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}


function activate(data: DCRecord): Promise<ActivateData> {
  const apiInstance = new api();
  const url = authApiUrl + "activate";

  return apiInstance
    .Call(url, "put", {
      email: data.email,
      activationToken: data.activation_token,
      password: data.password,
      password_new: data.password_new,
      appkey: appKey
    })
    .then((resp) => {
      if (resp.success) {
        const data = resp.data as LoginData;
        if (data.auth_token) {
          // store user details and basic auth credentials in local storage
          // to keep user logged in between page refreshes
          localStorage.setItem("auth_token", data.auth_token);
        }
      }
      return resp;
    });
}

function requestResetPassword(data: DCRecord): Promise<RequestResetPasswordData> {
  const apiInstance = new api();
  const url = authApiUrl + "password-reset-request";

  return apiInstance.Call(url, "post", {
    email: data.email,
    appkey: appKey
  })
  .then((resp) => {
    if (resp.success) {
      const data = resp.data as RequestResetPasswordData;
      return Promise.resolve(data);
    } else {
      return Promise.reject(resp.error);
    }
  })
  .catch((error) => {
    return Promise.reject(error);
  });
}

function resetPassword(data: DCRecord): Promise<ResetPasswordData> {
  const apiInstance = new api();
  const url = authApiUrl + "password-reset";

  return apiInstance
    .Call(url, "put", {
      //email: data.email,
      passwordreset_token: data.passwordreset_token,
      password: data.password_new
      //appkey: appKey
    })
    .then((resp) => {
      if (resp.success) {
        const data = resp.data as ResetPasswordData;
        return Promise.resolve(data);
      } else {
        return Promise.reject(resp.error);
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

function changePassword(data: DCRecord): Promise<ChangePasswordData> {
  const apiInstance = new api();
  const url = authApiUrl + "password-change";

  return apiInstance.Call(url, "put", {
    password: data.password,
    password_new: data.password_new
  })
  .then((resp) => {
    if (resp.success) {
      const data = resp.data as ChangePasswordData;
      return Promise.resolve(data);
    } else {
      return Promise.reject(resp.error);
    }
  })
  .catch((error) => {
    return Promise.reject(error);
  });

}


function wait(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function dummyLoginDelay(): Promise<DCRecord> {
  return wait(1000).then(() => {
    return dummyLogin();
  });
}

function dummyLogin(): DCRecord {
  localStorage.setItem("auth_token", "123");
  //return Promise.resolve({});
  return {
    code: 0,
    auth_token: "123",
    token_type: "bearer",
    email: "vanja@prehnit.hr",
    data: {
      user: {
        email: "vanja@prehnit.hr",
        firs_name: "Vanja",
        last_name: "Suhina",
        role_codes: [90]
      }
    }
  };
}

function login(email: string, password: string): Promise<LoginData> {
  const apiInstance = new api();
  const url = authApiUrl + "login";

  return apiInstance
    .Call(url, "post", {
      email: email,
      password: password
    })
    .then((resp) => {
      // console.log(resp);
      //login successful if there's a user in the response
      if (resp.success) {
        const data = resp.data as LoginData;
        if (data.code === 0) {
          if (data.auth_token) {
            // store user details and basic auth credentials in local storage
            // to keep user logged in between page refreshes
            localStorage.setItem("auth_token", data.auth_token);
          }
          return Promise.resolve(data);
        } else {
          return Promise.reject(data);
        }
      } else {
        return Promise.reject(resp.error);
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

function logout(): Promise<LogoutData> {
  const apiInstance = new api();

  return apiInstance
    .Call("auth/logout", "post")
    .then((resp) => {
      if (resp.success) {
        const data = resp.data as LogoutData;
        localStorage.setItem("auth_token", sifrarnici.publicToken);
        return Promise.resolve(data);
      } else {
        return Promise.reject(resp.error);
      }
    })
    .catch((err) => {
      localStorage.setItem("auth_token", sifrarnici.publicToken);
      return err;
    });
}

function whoAmI(): Promise<WhoAmIData> {
  const apiInstance = new api();
  return apiInstance
    .Call("auth/who-am-i", "get")
    .then((resp) => {
      if (resp.success) {
        const data = resp.data as WhoAmIData;
        if (data !== undefined) {
          return Promise.resolve(data);
        } else {
          return Promise.reject({});
        }
      } else {
        return Promise.reject({});
      }
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}
